// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollIcon_scroll__9Q7Rh","bounce":"ScrollIcon_bounce__QGKzM","show":"ScrollIcon_show__EBQpH","hide":"ScrollIcon_hide__M7Db-"};